// Mock data for Jerry Fisayo-Bambi's Portfolio

export const personalInfo = {
  name: "Jerry Fisayo-Bambi",
  title: "Award-Winning Journalist & Media Strategist",
  tagline: "Telling Africa's Stories to the World",
  shortBio: "An award-winning journalist, TV presenter, and communication strategist with a passion for telling compelling African stories. Currently a senior journalist at Euronews, host of Inspire Africa, and a sought-after moderator for high-profile events.",
  fullBio: `Jerry Fisayo-Bambi is an internationally acclaimed journalist whose career spans over fifteen years of impactful storytelling. As a senior journalist at Euronews, he brings African narratives to global audiences with depth, nuance, and authenticity.

As the host of "Inspire Africa," Jerry has interviewed countless leaders, innovators, and changemakers who are shaping the continent's future. His work goes beyond reporting—it's about amplifying voices that deserve to be heard on the world stage.

Beyond journalism, Jerry is a trusted voice in media campaigns and communication strategy, helping organizations craft compelling narratives that resonate with diverse audiences. His expertise in moderating high-stakes panels and conferences has made him a preferred choice for international summits and corporate events.

Recognized with prestigious awards including the NIDA Journalist of the Year and named among the 100 Outstanding Global Innovative Leaders, Jerry continues to push boundaries in journalism while inspiring the next generation of storytellers.`,
  email: "Jerry@fisayobambi.com",
  location: "Europe | Africa | Global"
};

export const stats = {
  awards: "10+",
  years: "15+",
  stories: "250+"
};

export const images = {
  hero: "https://customer-assets.emergentagent.com/job_0adaf51f-9101-4403-9fe3-28ee4c898b2b/artifacts/jt0s9b1f_WhatsApp%20Image%202026-01-02%20at%2001.04.46%20%281%29.jpeg",
  broadcasting: "https://customer-assets.emergentagent.com/job_0adaf51f-9101-4403-9fe3-28ee4c898b2b/artifacts/kt37wjnu_WhatsApp%20Image%202026-01-02%20at%2001.04.46%20%282%29.jpeg",
  moderating: "https://customer-assets.emergentagent.com/job_0adaf51f-9101-4403-9fe3-28ee4c898b2b/artifacts/rbqfvnai_WhatsApp%20Image%202026-01-02%20at%2001.04.46%20%283%29.jpeg",
  speaking: "https://customer-assets.emergentagent.com/job_0adaf51f-9101-4403-9fe3-28ee4c898b2b/artifacts/1v0tkohd_WhatsApp%20Image%202026-01-02%20at%2001.04.46.jpeg",
  casual: "https://customer-assets.emergentagent.com/job_0adaf51f-9101-4403-9fe3-28ee4c898b2b/artifacts/xrcnf17f_WhatsApp%20Image%202026-01-02%20at%2001.06.00.jpeg",
  gallery1: "https://customer-assets.emergentagent.com/job_0adaf51f-9101-4403-9fe3-28ee4c898b2b/artifacts/9pq9nc1w_DSC_1462_1100.jpg",
  gallery2: "https://customer-assets.emergentagent.com/job_0adaf51f-9101-4403-9fe3-28ee4c898b2b/artifacts/ioda2co8_DSCF5777.JPG",
  gallery3: "https://customer-assets.emergentagent.com/job_0adaf51f-9101-4403-9fe3-28ee4c898b2b/artifacts/upjsh43w_WhatsApp%20Image%202026-01-18%20at%2014.49.54.jpeg"
};

export const socialLinks = [
  { platform: "YouTube", handle: "@africaeuropeunpacked", url: "https://youtube.com/@africaeuropeunpacked?si=TBI7l_wMqbTAkZ29" },
  { platform: "Instagram", handle: "@fisayobambi", url: "https://www.instagram.com/fisayobambi" },
  { platform: "Twitter", handle: "@fisayobambi", url: "https://twitter.com/fisayobambi" },
  { platform: "TikTok", handle: "@fisayobambi", url: "https://www.tiktok.com/@fisayobambi" },
  { platform: "Facebook", handle: "Jerry Fisayo-Bambi", url: "https://www.facebook.com/jerry.bambi/" },
  { platform: "LinkedIn", handle: "Jerry Fisayo-Bambi", url: "https://www.linkedin.com/in/jerry-fisayo-bambi-5257009/" }
];

export const awards = [
  {
    id: 1,
    title: "NIDA Journalist of the Year Award",
    year: "2025",
    description: "Honoured at the Nigerians in the Diaspora Awards (NIDA) in Paris, recognised for excellence in journalism.",
    highlight: true
  },
  {
    id: 2,
    title: "100 Outstanding Global Innovative Leaders",
    year: "2025",
    description: "Named by the Global Centre for Innovative Leaders for impactful journalism and innovation.",
    highlight: true
  },
  {
    id: 3,
    title: "Forty Under 40 Africa Award",
    year: "2023",
    description: "Awarded a medal in the Journalism (TV/Radio) category at FortyUnder40Africa Awards.",
    highlight: false
  },
  {
    id: 4,
    title: "Voice Achievers Award",
    year: "2023",
    description: "Received Excellence in Journalism award at The Voice Achievers Awards in Almere, Netherlands.",
    highlight: false
  },
  {
    id: 5,
    title: "Bonteh Digital Media Award",
    year: "2022",
    description: "Recognized at the Bonteh Digital Media Awards in Cameroon for outstanding digital journalism.",
    highlight: false
  },
  {
    id: 6,
    title: "Nigeria Achievers Award - TV Presenter of the Year",
    year: "2020",
    description: "Named TV Presenter of the Year at The Achievers Awards International.",
    highlight: false
  },
  {
    id: 7,
    title: "BBC Komla Dumor Award - Shortlisted",
    year: "2016",
    description: "Selected as a candidate for this prestigious BBC journalism honour early in his career.",
    highlight: false
  }
];

export const articles = [
  // Inspire Africa Series
  {
    id: 1,
    title: "Tunde Onakoya: The Nigerian Changing Young Lives Across Africa with Chess",
    excerpt: "How a chess champion is using the game to transform the lives of young people across Africa and inspire a new generation.",
    category: "Inspire Africa",
    date: "2023-07-01",
    image: "https://customer-assets.emergentagent.com/job_0adaf51f-9101-4403-9fe3-28ee4c898b2b/artifacts/nomh6xtj_TUNDE.jpeg",
    url: "https://www.africanews.com/2023/07/01/tunde-onakoya-the-nigerian-changing-young-lives-across-africa-with-chess-inspire-africa/",
    featured: true
  },
  {
    id: 2,
    title: "South Africa's First 3D-Printed Low-Cost House",
    excerpt: "Innovation in construction and youth tech talent in Africa - showcasing groundbreaking solutions for affordable housing.",
    category: "Inspire Africa",
    date: "2023-03-04",
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800",
    url: "https://www.euronews.com/2023/03/04/south-africas-first-3d-printed-low-cost-house-inspire-africa",
    featured: true
  },
  {
    id: 3,
    title: "The Nigerian Art Curator Promoting Digital Artists",
    excerpt: "How digital art is being championed and promoted across Nigeria and the African continent.",
    category: "Inspire Africa",
    date: "2022-05-28",
    image: "https://images.unsplash.com/photo-1561214115-f2f134cc4912?w=800",
    url: "https://www.euronews.com/2022/05/28/the-nigerian-art-curator-promoting-digital-artists-inspire-africa",
    featured: false
  },
  {
    id: 4,
    title: "Peter Tabichi: Kenya's Million-Dollar Award-Winning Teacher",
    excerpt: "The inspiring story of a teacher who won the Global Teacher Prize and continues to transform education in rural Kenya.",
    category: "Inspire Africa",
    date: "2022-07-02",
    image: "https://customer-assets.emergentagent.com/job_0adaf51f-9101-4403-9fe3-28ee4c898b2b/artifacts/8kr6k4q0_TABICHI.jpeg",
    url: "https://www.euronews.com/2022/07/02/peter-tabichi-kenyas-million-dollar-award-winning-school-teacher-inspire-africa",
    featured: true
  },
  {
    id: 5,
    title: "The Congolese Woman Coffee Producer",
    excerpt: "Entrepreneurship and social impact from DRC - how one woman is transforming the coffee industry and empowering communities.",
    category: "Inspire Africa",
    date: "2021-04-24",
    image: "https://customer-assets.emergentagent.com/job_0adaf51f-9101-4403-9fe3-28ee4c898b2b/artifacts/djbx4unb_TISYA%20MUKUNA.jpeg",
    url: "https://www.africanews.com/2021/04/24/the-congolese-woman-coffee-producer-inspire-africa/",
    featured: false
  },
  {
    id: 6,
    title: "The Tanzanian Woman Bridging the Justice Gap",
    excerpt: "Digital justice innovation - how a digital platform is making legal services accessible to underserved communities in Tanzania.",
    category: "Inspire Africa",
    date: "2022-07-30",
    image: "https://images.unsplash.com/photo-1589391886645-d51941baf7fb?w=800",
    url: "https://www.euronews.com/2022/07/30/the-tanzanian-woman-bridging-the-justice-gap-with-a-digital-platform-inspire-africa",
    featured: false
  },
  {
    id: 7,
    title: "Jerry Malo: Nigeria's Award-Winning Fabrication Engineer",
    excerpt: "Spotlight on engineering innovation - the machines and inventions of one of Nigeria's most celebrated engineers.",
    category: "Inspire Africa",
    date: "2022-03-05",
    image: "https://customer-assets.emergentagent.com/job_0adaf51f-9101-4403-9fe3-28ee4c898b2b/artifacts/miaz1xee_JERRY%20MALO.jpg",
    url: "https://www.africanews.com/2022/03/05/the-machines-of-jerry-malo-nigeria-s-award-winning-fabrication-engineer-inspire-africa/",
    featured: false
  },
  {
    id: 8,
    title: "Start Lab: Incubator for Young Entrepreneurs in Congo",
    excerpt: "Entrepreneurship ecosystem development - nurturing the next generation of business leaders in the Democratic Republic of Congo.",
    category: "Inspire Africa",
    date: "2019-10-28",
    image: "https://customer-assets.emergentagent.com/job_0adaf51f-9101-4403-9fe3-28ee4c898b2b/artifacts/60058taf_START.jpg",
    url: "https://www.africanews.com/2019/10/28/start-lab-incubation-hub-for-congo-s-young-entrepreneurs-inspire-africa/",
    featured: false
  },
  {
    id: 9,
    title: "Self-Esteem Through Skin Care",
    excerpt: "How skincare entrepreneurship is empowering individuals and building self-confidence across Africa.",
    category: "Inspire Africa",
    date: "2023-06-03",
    image: "https://customer-assets.emergentagent.com/job_0adaf51f-9101-4403-9fe3-28ee4c898b2b/artifacts/ko86tu97_DR%20LU.jpeg",
    url: "https://www.africanews.com/2023/06/03/self-esteem-through-skin-care-inspire-africa/",
    featured: false
  },
  {
    id: 10,
    title: "The Ugandan Literacy Specialist Making a Difference with Disadvantaged Children",
    excerpt: "Literacy and youth empowerment in Uganda - innovative approaches to education for underserved communities.",
    category: "Inspire Africa",
    date: "2023-12-02",
    image: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=800",
    url: "https://www.africanews.com/2023/12/02/the-ugandan-literacy-specialist-making-a-difference-with-disadvantaged-children/",
    featured: false
  },
  // News & Political Reporting
  {
    id: 11,
    title: "Trump Threatens Nigeria with Military Action Amid Claims of Christian Persecution",
    excerpt: "Analysis on Trump's warning and Nigeria's response to allegations of religious persecution.",
    category: "Politics",
    date: "2025-11-03",
    image: "https://images.unsplash.com/photo-1580128660010-fd027e1e587a?w=800",
    url: "https://www.euronews.com/2025/11/03/trump-threatens-nigeria-with-military-action-amid-claims-of-christian-persecution",
    featured: true
  },
  {
    id: 12,
    title: "Botswana Calls for Deeper Trade Ties with EU Amid Trump's Tariffs",
    excerpt: "On Botswana's push for stronger EU economic relations as global trade dynamics shift.",
    category: "Economy",
    date: "2025-10-20",
    image: "https://customer-assets.emergentagent.com/job_0adaf51f-9101-4403-9fe3-28ee4c898b2b/artifacts/v3y9unna_BOTSWANA.jpeg",
    url: "https://www.euronews.com/my-europe/2025/04/10/botswana-calls-for-deeper-trade-ties-with-european-union-amid-trumps-tariffs",
    featured: false
  },
  {
    id: 13,
    title: "Africa's First G20 Summit Adopts Declaration",
    excerpt: "Coverage of Africa's inaugural hosting of a major global summit bridging EU and Africa policy as EU leaders respond to US peace plan for Ukraine.",
    category: "Diplomacy",
    date: "2025-09-15",
    image: "https://customer-assets.emergentagent.com/job_0adaf51f-9101-4403-9fe3-28ee4c898b2b/artifacts/1u26erxa_G20%20SOUTH%20AFRICA.jpeg",
    url: "https://www.euronews.com/my-europe/2025/11/19/africas-first-g20-summit-adopts-declaration-as-eu-leaders-respond-to-us-peace-plan-for-ukr",
    featured: true
  },
  {
    id: 14,
    title: "EU and African Union Ministers Vow to Strengthen Partnership",
    excerpt: "Focus on EU-AU cooperation and security issues amid geopolitical volatility.",
    category: "Diplomacy",
    date: "2025-01-21",
    image: "https://images.unsplash.com/photo-1529107386315-e1a2ed48a620?w=800",
    url: "https://www.euronews.com/my-europe/2025/01/21/eu-and-african-union-ministers-vow-to-strengthen-partnership-on-peace-and-security",
    featured: false
  },
  {
    id: 15,
    title: "Uganda Restricts Internet Access Amid Elections",
    excerpt: "Analysis on Uganda's internet restrictions during elections - the 15th African country to implement such measures.",
    category: "Politics",
    date: "2021-01-14",
    image: "https://images.unsplash.com/photo-1563986768609-322da13575f3?w=800",
    url: "https://www.africanews.com/2021/01/14/uganda-the-15th-country-in-africa-to-restrict-social-media-due-to-elections-report/",
    featured: false
  },
  // European Coverage
  {
    id: 16,
    title: "Elon Musk Hopes for Europe-US 'Free Trade Zone'",
    excerpt: "Elon Musk comments on transatlantic trade cooperation amid tariff disputes.",
    category: "Economy",
    date: "2025-04-06",
    image: "https://images.unsplash.com/photo-1614624532983-4ce03382d63d?w=800",
    url: "https://www.euronews.com/my-europe/2025/04/06/elon-musk-says-he-hopes-for-free-trade-zone-between-europe-and-the-us",
    featured: false
  },
  {
    id: 17,
    title: "Venezuela's Machado Presents Trump with Her Nobel Peace Prize During White House Meeting",
    excerpt: "María Corina Machado presents her Nobel Peace Prize to President Trump during a historic White House meeting.",
    category: "Politics",
    date: "2026-01-16",
    image: "https://customer-assets.emergentagent.com/job_0adaf51f-9101-4403-9fe3-28ee4c898b2b/artifacts/94u426by_TRUMP%20MACHADO.jpg",
    url: "https://www.euronews.com/2026/01/16/venezuelas-machado-presents-trump-with-her-nobel-peace-prize-during-white-house-meeting",
    featured: true
  },
  {
    id: 18,
    title: "Parts of Europe Cool Off After Extreme Heat Yet Risks Remain",
    excerpt: "Climate and weather conditions across Europe - analysis of extreme weather patterns.",
    category: "Climate",
    date: "2025-07-07",
    image: "https://images.unsplash.com/photo-1561484930-998b6a7b22e8?w=800",
    url: "https://www.euronews.com/my-europe/2025/07/07/parts-of-europe-cool-off-after-days-of-extreme-heat-yet-risks-remain",
    featured: false
  },
  {
    id: 19,
    title: "Austrian Government Prepares Deportation Plan for Syrian Migrants",
    excerpt: "Migration policy in the EU context - analysis of Austria's approach to Syrian migration.",
    category: "Migration",
    date: "2024-12-10",
    image: "https://images.unsplash.com/photo-1532375810709-75b1da00537c?w=800",
    url: "https://www.euronews.com/my-europe/2024/12/10/austrian-government-prepares-deportation-plan-for-syrian-migrants",
    featured: false
  },
  {
    id: 20,
    title: "Pilgrims Flock to Romania for Largest Catholic Pentecost Event in Europe",
    excerpt: "Cultural and religious reporting from Europe - coverage of one of the continent's largest religious gatherings.",
    category: "Culture",
    date: "2025-06-08",
    image: "https://images.unsplash.com/photo-1548625149-fc4a29cf7092?w=800",
    url: "https://www.euronews.com/2025/06/08/thousands-of-pilgrims-observe-traditional-pentecost-at-sumuleu-ciuc-in-romania",
    featured: false
  }
];

export const videos = [
  {
    id: 1,
    title: "Inspire Africa: Conversations with Changemakers",
    description: "A weekly series featuring interviews with Africa's most influential leaders and innovators.",
    thumbnail: "https://images.unsplash.com/photo-1478720568477-152d9b164e26?w=800",
    url: "https://www.youtube.com/playlist?list=PLcyzCW8o21whHInuTnK72HMtw9XC3e3p1",
    platform: "Euronews"
  },
  {
    id: 2,
    title: "The African Diaspora: Stories of Success",
    description: "Documenting the achievements of Africans making impact around the world.",
    thumbnail: "https://images.unsplash.com/photo-1489424731084-a5d8b219a5bb?w=800",
    url: "https://www.youtube.com/@fisayobambi",
    platform: "YouTube"
  },
  {
    id: 3,
    title: "Behind the Headlines: In-Depth Analysis",
    description: "Breaking down complex African stories with expert analysis and on-the-ground reporting.",
    thumbnail: "https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=800",
    url: "https://www.africanews.com/programmes/the-morning-call/",
    platform: "Africanews"
  }
];

export const moderatingSessions = [
  {
    id: 1,
    title: "Euronews Tech Summit 2025",
    event: "Meta Partnership Panel",
    description: "Moderated a high-level discussion on technology's role in African development with Meta executives and African tech leaders.",
    date: "2025-03-15",
    location: "Paris, France"
  },
  {
    id: 2,
    title: "African Union Summit",
    event: "Media & Communication Panel",
    description: "Led conversations on the future of African media and its role in continental integration.",
    date: "2024-11-20",
    location: "Addis Ababa, Ethiopia"
  },
  {
    id: 3,
    title: "Global Leaders Forum",
    event: "Innovation & Entrepreneurship",
    description: "Facilitated discussions between global investors and African startup founders.",
    date: "2024-09-08",
    location: "London, UK"
  }
];

export const services = [
  {
    id: 1,
    title: "Media Campaigns",
    description: "Strategic media campaign development and execution to amplify your brand's message.",
    icon: "megaphone"
  },
  {
    id: 2,
    title: "Communication Strategy",
    description: "Comprehensive communication strategies tailored to your organization's goals.",
    icon: "strategy"
  },
  {
    id: 3,
    title: "Event Moderation",
    description: "Professional moderation for conferences, panels, and corporate events.",
    icon: "microphone"
  },
  {
    id: 4,
    title: "Media Training",
    description: "Expert coaching to help leaders communicate effectively with the media.",
    icon: "training"
  }
];
